export const LOAD_ASSISTANT_PROGRESS = 'assistant/LOAD_ASSISTANT_PROGRESS';
